import { render, staticRenderFns } from "./accountants-voor-particulieren.vue?vue&type=template&id=92efaabe"
import script from "./accountants-voor-particulieren.vue?vue&type=script&lang=js"
export * from "./accountants-voor-particulieren.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports